import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function ComparisonTable() {
  return <section className="w-full py-20 px-6 md:px-10 lg:px-20 bg-gradient-to-b from-[#111] to-[#111]/90" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-lg font-semibold uppercase tracking-wider text-[#00E0FF] mb-3" data-id="element-15">
            Why Critical Voice Is Different
          </h2>
          <p className="text-3xl md:text-4xl font-bold" data-id="element-16">
            Unmatched in Every Category
          </p>
        </div>
        <div className="overflow-x-auto" data-id="element-17">
          <table className="w-full border-collapse" data-id="element-18">
            <thead data-id="element-19">
              <tr data-id="element-20">
                <th className="text-left py-4 px-4 border-b border-gray-800 text-lg" data-id="element-21">
                  Feature
                </th>
                <th className="text-center py-4 px-4 border-b border-gray-800 text-lg" data-id="element-22">
                  OpenAI / Google
                </th>
                <th className="text-center py-4 px-4 border-b border-gray-800 text-lg bg-[#3F00FF]/10" data-id="element-23">
                  Critical Voice
                </th>
              </tr>
            </thead>
            <tbody data-id="element-24">
              <tr className="hover:bg-[#222]/50 transition-colors" data-id="element-25">
                <td className="py-4 px-4 border-b border-gray-800" data-id="element-26">
                  Real-time latency
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 text-red-400" data-id="element-27">
                  <div className="flex items-center justify-center" data-id="element-28">
                    <XIcon className="w-5 h-5 mr-2" data-id="element-29" />
                    <span data-id="element-30">Noticeable delays</span>
                  </div>
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 bg-[#3F00FF]/10 text-[#00FF9D]" data-id="element-31">
                  <div className="flex items-center justify-center" data-id="element-32">
                    <CheckIcon className="w-5 h-5 mr-2" data-id="element-33" />
                    <span data-id="element-34">Near zero</span>
                  </div>
                </td>
              </tr>
              <tr className="hover:bg-[#222]/50 transition-colors" data-id="element-35">
                <td className="py-4 px-4 border-b border-gray-800" data-id="element-36">
                  Voice tone/emotion
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 text-red-400" data-id="element-37">
                  <div className="flex items-center justify-center" data-id="element-38">
                    <XIcon className="w-5 h-5 mr-2" data-id="element-39" />
                    <span data-id="element-40">Robotic, flat</span>
                  </div>
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 bg-[#3F00FF]/10 text-[#00FF9D]" data-id="element-41">
                  <div className="flex items-center justify-center" data-id="element-42">
                    <CheckIcon className="w-5 h-5 mr-2" data-id="element-43" />
                    <span data-id="element-44">Emotionally tuned</span>
                  </div>
                </td>
              </tr>
              <tr className="hover:bg-[#222]/50 transition-colors" data-id="element-45">
                <td className="py-4 px-4 border-b border-gray-800" data-id="element-46">
                  Use-case ready
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 text-red-400" data-id="element-47">
                  <div className="flex items-center justify-center" data-id="element-48">
                    <XIcon className="w-5 h-5 mr-2" data-id="element-49" />
                    <span data-id="element-50">Experimental</span>
                  </div>
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 bg-[#3F00FF]/10 text-[#00FF9D]" data-id="element-51">
                  <div className="flex items-center justify-center" data-id="element-52">
                    <CheckIcon className="w-5 h-5 mr-2" data-id="element-53" />
                    <span data-id="element-54">Deployable now</span>
                  </div>
                </td>
              </tr>
              <tr className="hover:bg-[#222]/50 transition-colors" data-id="element-55">
                <td className="py-4 px-4 border-b border-gray-800" data-id="element-56">
                  White-label
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 text-red-400" data-id="element-57">
                  <div className="flex items-center justify-center" data-id="element-58">
                    <XIcon className="w-5 h-5 mr-2" data-id="element-59" />
                    <span data-id="element-60">No</span>
                  </div>
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 bg-[#3F00FF]/10 text-[#00FF9D]" data-id="element-61">
                  <div className="flex items-center justify-center" data-id="element-62">
                    <CheckIcon className="w-5 h-5 mr-2" data-id="element-63" />
                    <span data-id="element-64">Yours, not ours</span>
                  </div>
                </td>
              </tr>
              <tr className="hover:bg-[#222]/50 transition-colors" data-id="element-65">
                <td className="py-4 px-4 border-b border-gray-800" data-id="element-66">
                  Customizable
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 text-yellow-400" data-id="element-67">
                  <div className="flex items-center justify-center" data-id="element-68">
                    <span data-id="element-69">⚠️ Limited</span>
                  </div>
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 bg-[#3F00FF]/10 text-[#00FF9D]" data-id="element-70">
                  <div className="flex items-center justify-center" data-id="element-71">
                    <CheckIcon className="w-5 h-5 mr-2" data-id="element-72" />
                    <span data-id="element-73">Deep prompt control</span>
                  </div>
                </td>
              </tr>
              <tr className="hover:bg-[#222]/50 transition-colors" data-id="element-74">
                <td className="py-4 px-4 border-b border-gray-800" data-id="element-75">Pricing</td>
                <td className="text-center py-4 px-4 border-b border-gray-800 text-red-400" data-id="element-76">
                  <div className="flex items-center justify-center" data-id="element-77">
                    <span data-id="element-78">💰 Expensive usage-based</span>
                  </div>
                </td>
                <td className="text-center py-4 px-4 border-b border-gray-800 bg-[#3F00FF]/10 text-[#00FF9D]" data-id="element-79">
                  <div className="flex items-center justify-center" data-id="element-80">
                    <span data-id="element-81">💸 Flat SaaS available</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}